module.exports = __webpack_public_path__ + "static/media/image4.980e2420.jpg";